// import React, { Component } from "react";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useSelector } from "react-redux";
import Utils from "../../utility/utility";
import DateField from "../../components/DateField";
import LoadingButton from "../../components/LoadingButton";
import { STRING } from "../../constants/string";
import { useNavigate, useParams } from "react-router-dom";
import {
  ANOUNCEMENT_HELPER,
  VIEW_ANNOUNCEMENT,
  ANNOUNCEMENT_CREATE,
  ANNOUNCEMENTS_UPDATES,
} from "../../service/apiUrl";
import { postApiCall } from "../../service/PostApiCall";

/* Error slot: always holds its line so a message never shifts the form. */
const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const AddAnouncements = (props) => {
  const [startDate, setStartDate] = useState(new Date());
  const [unpublishDate, setUnpublishDate] = useState(new Date());
  const dateformats = Utils.momentDate(startDate, STRING.SLASH_DATE_FORMAT);
  const dateformat1 = Utils.momentDate(unpublishDate, STRING.SLASH_DATE_FORMAT);
  const [Title, setTitle] = useState("");
  const [OptionSelect, setOptionSelect] = useState("");
  const [Description, setDescription] = useState("");
  const [helperData, setHelperData] = useState([]);
  const [errors, setErrors] = useState({});

  // clear each error as soon as its field has a value
  useEffect(() => {
    setErrors((prev) => {
      if (!Object.keys(prev).length) return prev;
      const next = { ...prev };
      if (next.Title && !Utils.isEmpty(Title)) delete next.Title;
      if (next.OptionSelect && !Utils.isEmpty(OptionSelect)) delete next.OptionSelect;
      if (next.startDate && !Utils.isEmpty(startDate)) delete next.startDate;
      if (next.Description && !Utils.isEmpty(Description)) delete next.Description;
      return Object.keys(next).length === Object.keys(prev).length ? prev : next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Title, OptionSelect, startDate, Description]);


  const announcement = useParams();
  const navigate = useNavigate();

  const signdata = useSelector((state) => state.signinReducers);
  const user_id = signdata?.data?.id;
  const access_token = signdata?.data?.access_token;

  useEffect(() => {
    postApiCall([], access_token, ANOUNCEMENT_HELPER)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("PROJECT_HELPER", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateannouncement = () => {
    // every check runs so all problems appear together
    const e = {};
    if (Utils.isEmpty(Title)) e.Title = STRING.TITLE;
    if (Utils.isEmpty(OptionSelect)) e.OptionSelect = STRING.STATUS;
    if (Utils.isEmpty(startDate)) e.startDate = STRING.DATE;
    if (Utils.isEmpty(Description)) e.Description = STRING.DESCRIPTION;
    setErrors(e);
    const message = Object.keys(e).length ? "invalid" : "";
    return message;
  };

  const createAnouncement = () => {
    const message = validateannouncement();
    if (message) {
      return false;
    } else {
      const objdata = {
        title: Title,
        status: OptionSelect?.value,
        publish_date: dateformats,
        unpublish_date: dateformat1,
        description: Description,
        updated_by: user_id,
        showSuccessToast: true
      };
      return postApiCall(objdata, access_token, ANNOUNCEMENT_CREATE).then(
        (response) => {
          navigate("/annoucement-listing");
        }
      );
    }
  };

  useEffect(() => {
    if (announcement && announcement?.announcement_id) {
      const parms = {
        access_token: access_token,
        id: announcement?.announcement_id,
      };
      postApiCall(parms, access_token, VIEW_ANNOUNCEMENT).then((result) => {
        setTitle(result?.title);
        setStartDate(Utils.getDate(result?.publish_date));
        setUnpublishDate(Utils.getDate(result?.unpublish_date));
        setDescription(result?.description);
        setOptionSelect(result?.status);
      });
    }
  }, [announcement]);

  const updateannouncement = () => {
    const message = validateannouncement();
    if (message) {
      Utils.toast("error", message);
      return false;
    } else {
      const updateobj = {
        id: announcement?.announcement_id,
        title: Title,
        status: OptionSelect?.value,
        publish_date: dateformats,
        unpublish_date: dateformat1,
        description: Description,
        updated_by: user_id,
      };
      return postApiCall(
        updateobj,
        access_token,
        ANNOUNCEMENTS_UPDATES,
        navigate
      ).then((response) => {
        Utils.toast("success", "Announcement updated successfully");
        navigate("/annoucement-listing");
      });
    }
  };

  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">Workplace</div>
            <h1 className="page-title">Add Announcement</h1>
          </div>
          <div className="col-md-6 manage">
            <div className="card-input mt-5 mb-2">
              <div className="col-md-12">
                <div className="mt-3">
                  <h5 className="border-bottom pb-2">Create Announcements</h5>
                </div>
                <form>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Title</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.Title ? " is-invalid" : "")}
                          value={Title}
                          onChange={(title) => {
                            setTitle(title.target.value);
                          }}
                          // placeholder="Enter Project Owner"
                        />
                        <FieldError msg={errors.Title} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Status</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                          options={helperData?.status}
                          placeholder="Please Select Status"
                          value={OptionSelect}
                          onChange={(status) => {
                            setOptionSelect({
                              label: status?.label,
                              value: status?.value,
                            });
                          }}
                        />
                        <FieldError msg={errors.OptionSelect} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Publish Date</label>
                        <DateField
                          value={startDate}
                          onChange={(date) => setStartDate(date)}
                          invalid={Boolean(errors.startDate)}
                        />
                        <FieldError msg={errors.startDate} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          UnPublish Date
                        </label>
                        <DateField
                          value={unpublishDate}
                          onChange={(date) => setUnpublishDate(date)}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Description</label>
                        <CKEditor
                          data={Description}
                          editor={ClassicEditor}
                          config={{
                            toolbar: [
                              "heading",
                              "|",
                              "bold",
                              "italic",
                              "blockQuote",
                              "link",
                              "numberedList",
                              "bulletedList",
                              "imageUpload",
                              "insertTable",
                              "tableColumn",
                              "tableRow",
                              "mergeTableCells",
                              "mediaEmbed",
                              "|",
                              "undo",
                              "redo",
                            ],
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setDescription(data);
                          }}
                        />
                        <FieldError msg={errors.Description} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row mb-5 mt-4">
                      <div className="">
                        {announcement && announcement?.announcement_id ? (
                          <LoadingButton
                            className="create-button"
                            successLabel="Saved"
                            onAction={updateannouncement}
                          >
                            Update
                          </LoadingButton>
                        ) : (
                          <LoadingButton
                            className="create-button"
                            successLabel="Created"
                            onAction={createAnouncement}
                          >
                            Create
                          </LoadingButton>
                        )}
                      </div>
                      <div className="ml-2">
                        <button
                          type="button"
                          className="create-button1 btn-info"
                          onClick={() => {
                            navigate("/annoucement-listing");                          
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAnouncements;
